export default null;throw new Error("Unable to resolve \"./bitpacker\" from npm:pngjs@5.0.0/browser.js");